import {store} from '../store'

export default (to, from, next) => {
    if (store.getters['admins/isLoggedIn']) {
        next()
    } else {
        next('/signin')
    }
}